<template>
  <div class="coupon-module" :style="{ background: background }">
    <div
      class="flex flex-between item-center"
      v-if="titleVisible"
      :style="{ color }"
    >
      <div class="title">{{ title }}</div>
      <div class="view-more">
        查看更多
        <span class="hmicon hmicon icon-youjiantou"></span>
      </div>
    </div>
    <div class="second-title" :style="{ color }" v-if="secTitleVisible">
      {{ secTitle }}
    </div>
    <div class="coupon-list" v-if="type === '1'">
      <div
        class="coupon-item flex"
        v-for="(item, index) in couponList"
        :key="index"
      >
        <div
          class="price-wrapper flex flex-column flex-center item-center"
          :style="{
            background:
              couponColorType === 'default' ? storeStyle.baseColor : couponColor
          }"
        >
          <div class="price" v-if="!item.discount">{{ item.account }}</div>
          <div class="discount" v-if="item.discount">{{ item.discount }}</div>
          <div>
            <div class="limit">满{{ item.levelMin }}使用</div>
          </div>
        </div>
        <div class="flex-1 info flex flex-column flex-center">
          <div class="name">{{ item.name }}</div>
          <div class="valid-time">有效期：{{ item.dateTime }}</div>
          <div>
            <button
              :style="{ background: storeStyle.baseColor }"
              class="btn round"
            >
              立即领取
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="coupon-list-row flex" v-if="type === '2'">
      <div
        class="coupon-item-row flex flex-column flex-between"
        v-for="(item, index) in couponList"
        :key="index"
        :style="{
          background:
            couponColorType === 'default' ? storeStyle.baseColor : couponColor
        }"
      >
        <div class="border"></div>
        <div class="top flex flex-column flex-center flex-1">
          <div class="price" v-if="!item.discount">{{ item.account }}</div>
          <div class="discount" v-if="item.discount">{{ item.discount }}</div>
          <div class="name">{{ item.name }}</div>
          <div>满{{ item.levelMin }}使用</div>
        </div>
        <div class="btn-wrapper">
          <div class="left-border"></div>
          <div class="right-border"></div>
          <button class="btn round" :style="{ color: storeStyle.baseColor }">
            立即领取
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    type: {
      type: String,
      default: "1"
    },
    title: {
      type: String,
      default: ""
    },
    titleVisible: {
      type: Boolean,
      default: true
    },
    secTitle: {
      type: String,
      default: ""
    },
    secTitleVisible: {
      type: Boolean,
      default: true
    },
    fillBgType: {
      type: String,
      default: "custom"
    },
    color: {
      type: String,
      default: "#2b2b2b"
    },
    bg: {
      type: String,
      default: "#ffffff"
    },
    couponColorType: {
      type: String,
      default: "default"
    },
    couponColor: {
      type: String,
      default: ""
    },
    couponList: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["storeStyle"]),
    background() {
      if (this.bg.indexOf("http") > -1) {
        return `url(${this.bg})`;
      } else {
        return this.bg;
      }
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.coupon-module {
  padding: 15px;
  overflow: hidden;
  background-size: 100% 100%;
  .view-more {
    font-size: 13px;
    opacity: 0.7;
    .iconfont {
      font-size: 12px;
    }
  }

  .title {
    font-weight: bold;
    font-size: 16px;
  }

  .second-title {
    font-size: 14px;
    margin: 10px 0;
    opacity: 0.7;
    word-break: break-all;
  }

  .coupon-item {
    overflow: hidden;
  }

  $baseWidth: 10px;

  .price-wrapper {
    position: relative;
    color: #fff;
    width: 95px;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    &::before {
      position: absolute;
      top: -($baseWidth / 2);
      right: -($baseWidth / 2);
      content: "";
      width: $baseWidth;
      height: $baseWidth;
      border-radius: 50%;
      background: #f4f4f4;
    }
    &::after {
      position: absolute;
      bottom: -($baseWidth / 2);
      right: -($baseWidth / 2);
      content: "";
      width: $baseWidth;
      height: $baseWidth;
      border-radius: 50%;
      background: #f4f4f4;
    }
  }

  .info {
    background: #fff;
    padding: 15px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .valid-time {
    font-size: 11px;
    color: #606060;
  }

  .name {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .coupon-item {
    margin-bottom: 10px;
  }

  .btn {
    width: 80px;
    height: 24px;
    margin-top: 8px;
    line-height: 24px;
    background: rgba(247, 43, 43, 1);
    border-radius: 12px;
    color: #fff;
    font-size: 13px;
    border: none;
  }

  .limit {
    font-size: 12px;
    margin-top: 10px;
  }

  .coupon-list-row {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .coupon-item-row {
    position: relative;
    margin-right: 12px;
    color: #fff;
    border-radius: 6px;
    flex-shrink: 0;
    text-align: center;
    min-height: 136px;
    width: 132px;
    overflow: hidden;
    > .border {
      position: absolute;
      border: 1px solid #fff;
      height: calc(100% - 6px);
      width: calc(100% - 6px);
      top: 2px;
      left: 2px;
      border-radius: 6px;
    }
    .top {
      padding: 15px;
    }
    .btn-wrapper {
      position: relative;
      border-top: 1px dashed #fff;
      padding: 7px 0 8px;
      .left-border {
        position: absolute;
        border: 1px solid #fff;
        width: $baseWidth + 2;
        height: $baseWidth;
        top: -($baseWidth / 2);
        left: -($baseWidth / 2);
        border-radius: 6px;
      }
      .right-border {
        position: absolute;
        border: 1px solid #fff;
        width: $baseWidth + 2;
        height: $baseWidth;
        top: -($baseWidth / 2);
        right: -($baseWidth / 2);
        border-radius: 6px;
      }
      .btn {
        margin: 0;
        background: #fff;
      }
      &::before {
        position: absolute;
        top: -($baseWidth / 2);
        left: -($baseWidth / 2);
        content: "";
        width: $baseWidth;
        height: $baseWidth;
        border-radius: 50%;
        background: #f4f4f4;
      }
      &::after {
        position: absolute;
        top: -($baseWidth / 2);
        right: -($baseWidth / 2);
        content: "";
        width: $baseWidth;
        height: $baseWidth;
        border-radius: 50%;
        background: #f4f4f4;
      }
    }
    .name {
      white-space: normal;
      word-break: break-all;
      word-wrap: break-word;
      margin: 10px 0;
      font-weight: bold;
    }
  }

  .price {
    font-size: 24px;
    color: #fff;
    &::before {
      content: "￥";
      font-size: 10px;
    }
  }
  .discount {
    font-size: 24px;
    color: #fff;
    &::before {
      content: "折";
      font-size: 10px;
    }
  }
}
</style>
